import {
  Box,
  Center,
  Flex,
  HStack,
  Spacer,
  Stack,
  Text,
} from '@chakra-ui/react';
import { OrderTemplate } from '@diamond/shared/types';
import { Button, IconButton } from '@diamond/shared/ui';
import { trackEvent } from '@diamond/shared/utils';
import { TRACKING_EVENTS, TRACKING_PAGES } from '@diamond/sol-buyer/constant';
import { DeleteOutlined } from '@mui/icons-material';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useRouter } from 'next/router';

export interface DesktopTemplateCardProps {
  data: OrderTemplate;
  handleDelete: () => void;
  handleAddtoCart: () => void;
  isLoadingDelete: boolean;
}

export function DesktopTemplateCard({
  data,
  handleDelete,
  handleAddtoCart,
  isLoadingDelete,
}: DesktopTemplateCardProps) {
  const router = useRouter();

  function handleTemplateDetail(templateId: string, warehouse: string) {
    trackEvent(TRACKING_EVENTS.CLICK_SHOPPING_LIST_DETAIL, {
      section_name: TRACKING_PAGES.SHOPPING_LIST,
    });
    router.push({
      pathname: `/daftar-belanja/${templateId}`,
      query: { warehouse: warehouse, page: 1 },
    });
  }

  function handleClikEdit(templateId: string, warehouse: string) {
    trackEvent(TRACKING_EVENTS.CLICK_EDIT_SHOPPING_LIST, {
      section_name: TRACKING_PAGES.SHOPPING_LIST,
    });
    router.push({
      pathname: `/daftar-belanja/edit/${templateId}`,
      query: { warehouse: warehouse, page: 1 },
    });
  }

  return (
    <Box
      w="full"
      shadow="base"
      rounded="lg"
      position="relative"
      py={{ base: '1rem', md: 6 }}
      px={{ base: 2, md: 6 }}
      my="10"
    >
      <Stack direction={['column', 'row']}>
        <Box>
          <Text
            as={'span'}
            fontWeight="bold"
            fontSize={{ base: 'lg', md: '2xl' }}
          >
            {data.name}
          </Text>
          <IconButton
            data-testid="btn-edit-template"
            mx="2"
            aria-label="min"
            name="min"
            icon={<ModeEditOutlineOutlinedIcon fontSize="medium" />}
            size="xs"
            color="blue"
            _hover={{
              bg: 'white',
              color: 'cyan',
            }}
            onClick={() => handleClikEdit(data.id, data.warehouse_id)}
          />
          <Text mt="24px" color="gray.75" fontSize="14px">
            {data.note}
          </Text>
        </Box>
        <Spacer />
      </Stack>
      <Flex justifyContent="flex-end">
        <Box rounded="lg">
          <Center>
            <HStack>
              <IconButton
                data-testid="btn-delete-template"
                onClick={() => handleDelete()}
                p="5"
                aria-label="min"
                name="min"
                id="btn-delete-daftar-belanja"
                icon={<DeleteOutlined />}
                size="xs"
                color="red"
                borderColor="red"
                variant="outline"
                _hover={{
                  bg: 'red',
                  color: 'white',
                  borderColor: 'red',
                }}
                isLoading={isLoadingDelete}
              />
              <Button
                w="full"
                color="azure"
                borderColor="azure"
                fontSize="16px"
                onClick={() => handleTemplateDetail(data.id, data.warehouse_id)}
                className="btn-see-detail"
              >
                Lihat Detail
              </Button>
              <Button
                fontSize={{ base: '14px', md: '18px' }}
                w="full"
                bg="blue"
                color="white"
                variant="solid"
                _hover={{
                  bg: 'navy',
                }}
                onClick={handleAddtoCart}
              >
                + Keranjang
              </Button>
            </HStack>
          </Center>
        </Box>
      </Flex>
    </Box>
  );
}

export default DesktopTemplateCard;
